// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"74cc903f","665":"b67789a4"}[chunkId] + ".chunk.css";
};